import img1 from '../img/portImages/1.png';
import img2 from '../img/portImages/2.png';
import img3 from '../img/portImages/3.png';

const portfolios = [
    {
        id: 1,
        category: 'Javascript',
        image: img1,
        link1: 'https://github.com/aa-nadim/Like-Electronics-client-side',
        link2: 'https://like-electronics.web.app/',
        title: 'Like-Electronics Servicing Website',
        text: `“Like-Electronics” is full stack (MERN) website with Google Sign in, where an user/customer can visit
        the website and book events with credit card payment which is implemented with stripe. Admin and user have
        different dashboards. Admins have restricted access and they can see, update and manage customer's bookings
        and change their status accordingly.`
    },
    {
        id: 2,
        category: 'Javascript',
        image: img2,
        link1: 'https://github.com/aa-nadim/electronics-shop-client',
        link2: 'https://electronics-shop-clien.web.app/',
        title: 'Electronics-Shop Ecommerce Website',
        text: `A full stack ecommerce website with user login/sign up option by email or Google implemented with
        firebase authentication, where customers can buy, cancel or review their orders and admin can add, delete or
        update products. These features are executed using CRUD operation by Node, Express, and MongoDB.`
    },
    {
        id: 3,
        category: 'Javascript',
        image: img3,
        link1: 'https://github.com/aa-nadim/metropolitan-transport',
        link2: 'https://auth-rec.web.app/',
        title: 'Metropolitan-Transport Website',
        text: `React website using react router, firebase authentication. On this website, user can select their
        preferred vehicles and compare cost of those vehicles for their preferred routes.`
    }
]

export default portfolios;